export interface OptionsGasParams {
    gasPrice?: string;
    gasLimit?: string;
    maxPriorityFeePerGas?: string;
    maxFeePerGas?: string;
}

export interface TransactionGasParams {
    gas?: string;
    gasPrice?: string;
    maxPriorityFeePerGas?: string;
    maxFeePerGas?: string;
}
